// https://stackoverflow.com/a/30970691
// utilize regex to extract individual RGB values from hex colors
import type { PartnerTheme } from "src/types/shared/partners";

const altColorTeams = new Set([
  "GeorgiaTechYellowJacketsBasketball",
  "GeorgiaTechYellowJacketsFootball",
  "NorthCarolinaTarHeelsBasketball",
  "NorthCarolinaTarHeelsFootBall",
]);

export const getPartnerColor = (theme: PartnerTheme, name: Maybe<string>) =>
  name && altColorTeams.has(name) ? theme.colors?.backgroundAccent100 : theme.colors?.backgroundBrandActive;
